// extracted by mini-css-extract-plugin
export default {"textBlockWrapper":"OrganizationTextBlockOrganism_textBlockWrapper__Jqknd","button":"OrganizationTextBlockOrganism_button__5iN9C"};